import React, { ReactNode } from 'react';
import { BackgroundColorProps, BackgroundProps, BorderProps, ColorProps, FlexboxProps, GridProps, LayoutProps, PositionProps, ShadowProps, SpaceProps, TypographyProps } from 'styled-system';
import { Box, BoxProps } from '../next-components/box';
import { Typography } from './Typography';
type StyledSystemProps = BackgroundProps & BackgroundColorProps & BorderProps & ColorProps & FlexboxProps & GridProps & LayoutProps & PositionProps & ShadowProps & SpaceProps & TypographyProps;
export type Props = BoxProps & {
  value?: string;
  children?: ReactNode;
  textProps?: StyledSystemProps;
};
export const Chip = ({
  value,
  children,
  textProps,
  ...rest
}: Props) => <Box borderRadius="16px" display="inline-flex" border="1px solid black" verticalAlign="center" justifyContent="center" textDecoration="none" style={{
  whiteSpace: 'nowrap'
}} {...rest} data-sentry-element="Box" data-sentry-component="Chip" data-sentry-source-file="Chip.tsx">
    {children || <Typography variant="body2" px="12px" py="4px" color="#3A5080" fontWeight="bold" {...textProps}>
        {value}
      </Typography>}
  </Box>;
export type ChipProps = Props;